/*
  Scheduling Expandable Activity

  Handles expanding schedulable activities on a scheduling calendar.

  EMITTED EVENTS
    calendarActivityUpdateSuccess (document) Emits after successfully updating the activity on the server
      detail: {
        el:           the root element of this controller instance,
        activityType: the type of activity that was updated ('Task', 'Milestone', etc.),
        res:          the response from the server
      }
*/

import ExpandableActivityController from './expandable-activity-controller';
import { createCustomEvent } from '../../shared/helpers';

export default class extends ExpandableActivityController {
  static targets = ['expandedContentContainer', 'closeLink', 'remoteForm'];

  renderExpandedOptions() {
    if (!this.isExpanded) {
      this.expandedContent = this.expandOptionsForm;
      this.openExpandedContent();
    }
  }

  renderExpandedContent(event) {
    this.fetchAndRenderContent(event);
  }

  renderReassignForm(event) {
    this.fetchAndRenderContent(event, this.reassignFormURL);
  }

  fetchAndRenderContent(event, url=this.url) {
    event && event.stopImmediatePropagation();
    event && event.preventDefault();
    document.removeEventListener('click', this.closeIfOutsideClick);
    this.expandedContent = '';
    this.openExpandedContent(null, url);
  }

  submitReassignForm(event) {
    event && event.preventDefault();
    event && event.stopImmediatePropagation();
    $.ajax(this.remoteFormTarget.action, {
      method: 'post',
      data: $(this.remoteFormTarget).serialize()
    }).done(this.updateActivity.bind(this));
    this.expandedContent = App.spinner();
  }

  //
  // GETTERS AND SETTERS
  //

  updateActivity(response) {
    this.closeExpandedContent();
    this.element.remove();
    document.dispatchEvent(createCustomEvent('calendarActivityUpdateSuccess', this.element, {
      activityType: this.activityType,
      res:          response
    }));
  }

  get expandOptionsForm() {
    return `
      <div class="expand-options">
        ${this.expandLink}
        <a data-action="${this.controller}#renderReassignForm" class="btn btn-sm btn-default">Reassign</a>
      </div>
    `;
  }

  get expandLink() {
    return this[`expand${this.activityType}Link`]
  }

  get expandTaskLink() {
    return App.Task.taskSlideOutLinkForURL(this.url, "Expand Task Details", "btn btn-sm btn-default")
  }

  get expandMilestoneLink() {
    return `
      <a data-action="${this.controller}#renderExpandedContent" class="btn btn-sm btn-default">
        Expand Milestone Details
      </a>
    `
  }

  get activityType() {
    return this.data.get('activity-type');
  }

  get reassignFormURL() {
    return this.data.get('reassign-form-url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/scheduling-expandable-activity-controller.js